import { render, staticRenderFns } from "./COMBO.vue?vue&type=template&id=05895d8e&"
import script from "./COMBO.vue?vue&type=script&lang=js&"
export * from "./COMBO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports